module.exports = __webpack_public_path__ + "img/mi_x.46f9d873.jpg";